/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import {FC, useEffect, useState} from 'react'
import {Alert, Form as BsForm} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
//compoenents
import ChartDashboard from './ChartDashboard'
import ConfigDashboard from './ConfigDashboardCard'
import DashboardTablePage from './DashboardTablePage'
import VerifyEmailModal from './VerifyEmailModal'
//style
import './DashboardPage.scss'
import React from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {GetAllData as businessName} from '../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {sendEmailOtp} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {getAllTemplate} from '../MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {GetAllCategory} from '../MyTemplate/OurTemplates/OurTemplateSlice/OurTemplateSlice'
import {GetAllData as FetchLandingPage} from '../LandingPage/LandingPageSlice/LandingPageSlice'
import {GetAllData as CustomOptout} from '../Opt_out/OptoutSlice/OptoutListSlice'
import {GetAllData as TagsList} from '../Contacts/Tags/TagSlice/TagsSlices'
import {GetData} from '../Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import {
  useGetAllCampaignListReportQuery,
  useGetDashboardActivityOverviewGraphQuery,
  useGetDashboardClickCountQuery,
  useGetDashboardEngagementAndRetentionGraphQuery,
  useGetDashboardGraphQuery,
  useGetDashboardLeadGraphQuery,
  useGetDashboardRecentInboundMessagesQuery,
} from '../../../../services/cellcast'
import {
  profileOptions,
  selectedProfile,
  setSelectedDashboard,
} from '../../../Redux/FrontEnd/ProDashboardSlices/ProDashboardSlice'
import Select from 'react-select'

const DashboardPage: FC = () => {
  const dispatch = useDispatch()
  const userValues = useSelector(getAllUserDetails)

  const activeProfile = useSelector(selectedProfile)
  const activeProfileOptions = useSelector(profileOptions)

  const email = userValues?.email
  const mobile = userValues?.mobile

  const [visible, setVisible] = useState(false)
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [campType, setCampType] = useState('sms')
  const [whereWhen, setWhereWhen] = useState<any>({
    start: sevenDaysAgo,
    end: new Date(),
  })

  const FELeadGraph = useGetDashboardLeadGraphQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
    camp_type: campType,
  })

  const FEActivity = useGetDashboardActivityOverviewGraphQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
    camp_type: campType,
  })

  const FEDashboardGraph = useGetDashboardGraphQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
  })

  const FEInbound = useGetDashboardRecentInboundMessagesQuery({
    camp_type: campType,
  })

  const FEDashboardState = useGetDashboardClickCountQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
  })

  const FEActivityTable = useGetAllCampaignListReportQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
    campType,
    dashboardApi: true,
  })

  useGetDashboardEngagementAndRetentionGraphQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
  })

  useEffect(() => {
    dispatch(businessName())
    dispatch(fetchAsyncUserDetails())
  }, [])

  useEffect(() => {
    dispatch(CustomOptout())
    dispatch(FetchLandingPage())
    dispatch(GetAllCategory())
    dispatch(getAllTemplate())

    dispatch(GetData())
    dispatch(TagsList())
  }, [])

  return (
    <>
      {userValues?.isEmailVerified === false && (
        <VerifyEmailModal
          show={visible}
          handleClose={setVisible}
          email={email}
          mobile={mobile}
          data={userValues}
        />
      )}

      {userValues?.isEmailVerified === false && (
        <div className='d-flex justify-content-start'>
          <Alert
            variant={'warning'}
            className='w-500px alert-message position-fixed'
            style={{marginTop: '-12px'}}
          >
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-2x svg-icon-warning me-4'
            />
            Your email hasn't been verified, please{' '}
            <Alert.Link
              href='#'
              className='text-primary'
              onClick={() => {
                setVisible(true)
                dispatch(
                  sendEmailOtp({
                    email: email,
                  })
                )
              }}
            >
              verify your email
            </Alert.Link>
          </Alert>
        </div>
      )}

      <div className='ReportDatePicker' style={{maxWidth: 550}}>
        <div className='row' style={{position: 'relative'}}>
          <div className='col-5 d-flex align-items-center px-2'>
            <div className='col-12  d-flex align-items-center px-2'>
              <Select
                options={activeProfileOptions}
                value={
                  activeProfileOptions?.find((key: any) => key?.value === activeProfile) ||
                  activeProfileOptions[0]
                }
                onChange={(e: any) => {
                  dispatch(setSelectedDashboard(e.value))
                }}
                className='bg-white form-select form-select-solid form-select-lg'
              />
            </div>
          </div>

          <span className='col-3 p-0'>
            <DatePicker
              dateFormat='dd-MM-yyyy'
              className=' bg-white rounded-0 border-0 form-control form-control-lg form-control-solid'
              selected={whereWhen?.start}
              onChange={(date: any) => setWhereWhen({...whereWhen, start: date})}
              selectsEnd
              startDate={whereWhen?.start}
              endDate={whereWhen?.end}
              maxDate={whereWhen?.end}
            />
          </span>
          <span className='col-4 ps-0'>
            <DatePicker
              dateFormat='dd-MM-yyyy'
              className=' ps-0 bg-white rounded-0 border-0 form-control form-control-lg form-control-solid'
              selected={whereWhen?.end}
              onChange={(date: any) => {
                setWhereWhen({...whereWhen, end: date})
              }}
              selectsEnd
              startDate={whereWhen?.start}
              endDate={whereWhen?.end}
              minDate={whereWhen?.start}
            />
          </span>
          <i
            className='fas fa-calendar absolute'
            style={{position: 'absolute', width: 'auto', right: '20px', top: '15px'}}
          ></i>
        </div>
      </div>

      <div className='dahboard-main'>
        <div className='row'>
          <ChartDashboard
            FELeadGraph={FELeadGraph}
            FEInbound={FEInbound}
            FEActivity={FEActivity}
            campType={campType}
            whereWhen={whereWhen}
            FEDashboardState={FEDashboardState}
            FEDashboardGraph={FEDashboardGraph}
          />
        </div>

        <div className='row'>
          <ConfigDashboard whereWhen={whereWhen} />
        </div>
        <div className='row'>
          <DashboardTablePage FEActivityTable={FEActivityTable} whereWhen={whereWhen} />
        </div>
      </div>
    </>
  )
}

export default React.memo(DashboardPage)
